import Image from "@tiptap/extension-image";
import { mergeAttributes } from "@tiptap/core";

const ImageWithStatus = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      uploadError: { default: null },
    };
  },

  renderHTML({ HTMLAttributes }) {
    const { uploadError, ...rest } = HTMLAttributes;
    const baseImage = [
      "img",
      mergeAttributes(this.options.HTMLAttributes, rest),
    ];

    if (uploadError) {
      return [
        "span",
        mergeAttributes(
          {
            class: "kb-media-wrapper kb-media-wrapper--image",
            "data-upload-error": uploadError,
          },
          this.options.HTMLAttributes
        ),
        baseImage,
        [
          "span",
          { class: "kb-media-error" },
          uploadError || "Upload failed. Remove and try again.",
        ],
      ];
    }

    return baseImage;
  },
});

export default ImageWithStatus;
